import { render, staticRenderFns } from "./BeneficiaryItemCard.vue?vue&type=template&id=6cda5d24&"
import script from "./BeneficiaryItemCard.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports